import { Reducer } from 'redux';

import { DictionaryController } from '@/controllers/Dictionary';
import { ActivitiesActionTypes } from '@/store/reducers/activities/action-types';
import { STATUS } from '@/store/reducers/api-requests/constants';

import { DictionariesActionTypes } from './action-types';
import { initialState } from './constants';
import { DictionariesReducerState as State } from './types';

export const dictionariesReducer: Reducer<State> = (state = initialState, action): State => {
  switch (action.type) {
    case DictionariesActionTypes.FETCH_REQUEST_NEW_PROPOSAL_REASONS.SUCCESS:
      return {
        ...state,
        requestNewProposalReasons: action.payload.map(option => ({
          id: option.id,
          title: option.title || option.label,
          code: option.code || option.value,
          default: option.default,
        })),
      };

    case DictionariesActionTypes.FETCH_PROPOSAL_ITEMS.SUCCESS:
      return { ...state, proposalItems: action.payload };

    case ActivitiesActionTypes.FETCH_ACTIVITY_DETAILS_DATA.START:
      return { ...state, proposalItems: undefined };

    default:
  }

  // action.type example: user|updateProfile:start
  const [requestName, requestStatus] = action.type.split(':');
  const [instance] = requestName.split('|');

  if (instance === 'dictionaries' && requestStatus === STATUS.SUCCESS) {
    return {
      ...state,
      [action.sagaPayload.dictionaryName]: DictionaryController.convertFromAPIDataToReduxData(
        action.payload,
      ),
    };
  }

  return state;
};
